import { Model } from '../types/BookingTypes';
import { API_BASE_URL } from '../constants';

const CDN_BASE_URL = 'https://admin.mintomein.in/public/uploads/';

export async function getModelsByBrandId(brandId: number): Promise<Model[]> {
  const response = await fetch(`${API_BASE_URL}/model/${brandId}/models`, {
    headers: {
      'accept': 'application/json, text/plain, */*',
    },
  });
  if (!response.ok) {
    throw new Error('Failed to fetch models');
  }
  const data = await response.json();
  return (data.entity || []).map((item: any) => ({
    id: item.id,
    brandId: brandId,
    name: item.name,
    image: item.imagePath.startsWith('http') ? item.imagePath : `${CDN_BASE_URL}${item.imagePath}`,
  }));
} 